import {useEffect, useState} from 'react';
import {useGetDepartmentsInSummary} from '../../../core/repositories/reportSummaryRepository';

type Props = {
  selectionReportType?: string;
  companyId: number;
  departmentId?: number;
};

export const useHandleReportSummaryUrl = ({
  selectionReportType,
  companyId,
  departmentId,
}: Props) => {
  const [reportSummaryUrl, setReportSummaryUrl] = useState<string>(
    '/report_analytics/search',
  );
  if (departmentId === undefined || selectionReportType === undefined) {
    return {
      reportSummaryUrl,
    };
  }

  const reportType = ['summer', 'winter', 'spring', 'autumn'].includes(
    selectionReportType,
  )
    ? 'intern'
    : selectionReportType;

  const {data: departmentsData} = useGetDepartmentsInSummary({
    companyID: companyId,
    queryParams: {reportType},
  });

  useEffect(() => {
    if (departmentsData?.ok) {
      for (const department of departmentsData.value.departments) {
        if (department.departmentID === departmentId) {
          setReportSummaryUrl(
            `/report_analytics/result/${companyId}/${departmentId}?reportType=${reportType}`,
          );
        }
      }
    }
  }, [departmentsData]);

  return {
    reportSummaryUrl,
  };
};
